import type theme from '#build/ui/button'

export default {
	slots: {
		base: [
			'rounded-xs font-medium inline-flex items-center justify-center disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:opacity-75',
			'transition-colors'
		],
		label: 'truncate',
		leadingIcon: 'shrink-0',
		leadingAvatar: 'shrink-0',
		leadingAvatarSize: '',
		trailingIcon: 'shrink-0'
	},
	variants: {
		buttonGroup: {
			horizontal: 'not-only:first:rounded-e-none not-only:last:rounded-s-none not-last:not-first:rounded-none',
			vertical: 'not-only:first:rounded-b-none not-only:last:rounded-t-none not-last:not-first:rounded-none'
		},
		color: {
			primary: '',
			secondary: '',
			success: '',
			info: '',
			warning: '',
			error: '',
			neutral: ''
		},
		variant: {
			solid: '',
			outline: '',
			soft: '',
			subtle: '',
			ghost: '',
			link: ''
		},
		size: {
			xs: {
				base: 'px-2 py-1 text-xs gap-1',
				leadingIcon: 'size-4',
				leadingAvatarSize: '3xs',
				trailingIcon: 'size-4'
			},
			sm: {
				base: 'px-2.5 py-1.5 text-xs gap-1.5',
				leadingIcon: 'size-4',
				leadingAvatarSize: '3xs',
				trailingIcon: 'size-4'
			},
			md: {
				base: 'px-2.5 py-1.5 text-sm gap-1.5',
				leadingIcon: 'size-5',
				leadingAvatarSize: '2xs',
				trailingIcon: 'size-5'
			},
			lg: {
				base: 'px-3 py-2 text-sm gap-2',
				leadingIcon: 'size-5',
				leadingAvatarSize: '2xs',
				trailingIcon: 'size-5'
			},
			xl: {
				base: 'px-4 py-3 text-base gap-2.5',
				leadingIcon: 'size-7',
				leadingAvatarSize: 'sm',
				trailingIcon: 'size-7'
			}
		},
		block: {
			true: {
				base: 'w-full justify-center',
				trailingIcon: 'ms-auto'
			}
		},
		square: {
			true: ''
		},
		leading: {
			true: ''
		},
		trailing: {
			true: ''
		},
		loading: {
			true: ''
		},
		active: {
			true: {
				base: ''
			},
			false: {
				base: ''
			}
		}
	},
	compoundVariants: [
		{
			color: 'primary',
			variant: 'solid',
			class: 'text-inverted bg-primary hover:bg-primary/75 disabled:bg-primary aria-disabled:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'
		},
		{
			color: 'primary',
			variant: 'outline',
			class: 'ring ring-inset ring-primary/50 text-primary hover:bg-primary/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-primary'
		},
		{
			color: 'primary',
			variant: 'soft',
			class: 'text-primary bg-primary/10 hover:bg-primary/15 focus:outline-none focus-visible:bg-primary/15 disabled:bg-primary/10 aria-disabled:bg-primary/10'
		},
		{
			color: 'primary',
			variant: 'subtle',
			class: 'text-primary ring ring-inset ring-primary/25 bg-primary/10 hover:bg-primary/15 disabled:bg-primary/10 aria-disabled:bg-primary/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary'
		},
		{
			color: 'primary',
			variant: 'ghost',
			class: 'text-primary hover:bg-primary/10 focus:outline-none focus-visible:bg-primary/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent'
		},
		{
			color: 'primary',
			variant: 'link',
			class: 'hover:underline decoration-primary decoration-2 underline-offset-2 text-primary disabled:text-primary aria-disabled:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary'
		},
		{
			color: 'neutral',
			variant: 'solid',
			class: 'text-highlighted bg-default hover:bg-muted/90 disabled:bg-dimmed aria-disabled:bg-dimmed focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-inverted'
		},
		{
			color: 'neutral',
			variant: 'outline',
			class: 'ring ring-inset ring-inverted text-inverted/90 bg-transparent hover:bg-default/15 hover:text-inverted disabled:bg-elevated aria-disabled:bg-default focus:outline-none focus-visible:ring-2 focus-visible:ring-inverted'
		},
		{
			color: 'neutral',
			variant: 'soft',
			class: 'text-default bg-elevated hover:bg-accented/75 focus:outline-none focus-visible:bg-accented/75 disabled:bg-elevated aria-disabled:bg-elevated'
		},
		{
			color: 'neutral',
			variant: 'subtle',
			class: 'ring ring-inset ring-accented text-default bg-elevated hover:bg-accented/75 disabled:bg-elevated aria-disabled:bg-elevated focus:outline-none focus-visible:ring-2 focus-visible:ring-inverted'
		},
		{
			color: 'neutral',
			variant: 'ghost',
			class: 'text-default hover:bg-accented/8 focus:outline-none focus-visible:bg-accented/8 hover:disabled:bg-transparent dark:hover:disabled:bg-transparent hover:aria-disabled:bg-transparent dark:hover:aria-disabled:bg-transparent'
		},
		{
			color: 'neutral',
			variant: 'link',
			class: 'text-muted hover:text-default disabled:text-muted aria-disabled:text-muted focus:outline-none focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-inverted'
		},
		{
			color: 'secondary',
			variant: 'ghost',
			class: 'text-inverted hover:bg-accented/25 focus:outline-none focus-visible:bg-accented/25 hover:disabled:bg-transparent dark:hover:disabled:bg-transparent hover:aria-disabled:bg-transparent dark:hover:aria-disabled:bg-transparent'
		},
		{
			size: 'xs',
			square: true,
			class: 'p-1'
		},
		{
			size: 'sm',
			square: true,
			class: 'p-1.5'
		},
		{
			size: 'md',
			square: true,
			class: 'p-1.5'
		},
		{
			size: 'lg',
			square: true,
			class: 'p-2'
		},
		{
			size: 'xl',
			square: true,
			class: 'p-3'
		},
		{
			loading: true,
			leading: true,
			class: {
				leadingIcon: 'animate-spin'
			}
		},
		{
			loading: true,
			leading: false,
			trailing: true,
			class: {
				trailingIcon: 'animate-spin'
			}
		}
	],
	defaultVariants: {
		color: 'primary',
		variant: 'solid',
		size: 'md'
	}
} satisfies Partial<typeof theme>
